import React, { useState } from "react";
import "./JumpseatPage.css";
import TopNav from "../components/TopNav";
import BackButton from "../components/BackButton";
import axios from "axios";

const JumpseatPage = (props) => {
  const [stage, setStage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [cost, setCost] = useState(null);
  const [mesg, setMesg] = useState(null);
  const [dest, setDest] = useState("XXXX");
  // const [darkMode, setDarkMode] = useState(props.darkmode || false);
  const [updatedFunds, setUpdatedFunds] = useState(null);
  const [updatedJumpseats, setUpdatedJumpseats] = useState(null);
  const [showLocationModal, setShowLocationModal] = useState(false);

  
  // handleForm2  costs info on the selected jumpseat ------------------------- form2
  const handleForm2 = async (e) => {
    // 1. Always prevent default first
    e.preventDefault();
    // 2. Clear previous errors and start loading
    setLoading(true);
    setError(null); // Assuming you have an error state

    // 3. Extract data (Assuming this is an onSubmit handler, e.currentTarget is the form)
    const formData = new FormData(e.currentTarget);
    const form = formData.get("form");
    const dest = formData.get("dest");
    const cost = formData.get("cost");

    console.log("form:" + form + " dest:" + dest + " cost:" + cost);

    try {
      // 4. Clean API call using Axios config object
      const { data } = await axios.get("/api/jumpseat", {
        params: {
          form,
          dest,
          cost,
          _t: Date.now(), // cleaner cache-buster than Math.random()
        },
      });

      // Handle data responses here
      if (data) {
        console.log(data);
        if (data.result === "error") {
          console.log("Error message: " + data.mesg);
          setError(data.mesg);
        }
        if (data.result === "success") {
          // Calculate new funds after purchase (ensure cost is a number)
          const costNum = parseFloat(cost);
          const currentFunds = parseFloat(props.pilotData.funds) || 0;
          const currentJumpseats = parseInt(props.pilotData.jumpseats) || 0;
          
          // Use API values if provided, otherwise calculate locally
          const newFunds = (data.funds !== undefined && data.funds !== null)
            ? parseFloat(data.funds)
            : (currentFunds - costNum);
          const newJumpseats = (data.jumpseats !== undefined && data.jumpseats !== null)
            ? parseInt(data.jumpseats)
            : currentJumpseats;
          
          console.log("API response data:", data);
          console.log("Cost:", costNum, "Current funds:", currentFunds, "New funds:", newFunds);
          console.log("Current jumpseats:", currentJumpseats, "New jumpseats:", newJumpseats);
          
          // Update local state for display
          setUpdatedFunds(newFunds);
          setUpdatedJumpseats(newJumpseats);
          
          // Update pilotData with new values
          if (props.setPilotData) {
            const updatedData = {
              ...props.pilotData,
              funds: newFunds,
              jumpseats: newJumpseats,
              location: dest
            };
            props.setPilotData(updatedData);
            // Update localStorage so Dashboard and other pages see the changes
            localStorage.setItem("userData", JSON.stringify(updatedData));
          }
          setStage(3);
        }
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("Failed to fetch jumpseat info. Please try again.");
    } finally {
      // 5. This runs regardless of success or failure
      setLoading(false);
    }
  };

  // handleForm1  costs info on the selected jumpseat
  const handleForm1 = async (e) => {
    // 1. Always prevent default first
    e.preventDefault();

    // 2. Clear previous errors and start loading
    setLoading(true);
    setError(null); // Assuming you have an error state

    // 3. Extract data (Assuming this is an onSubmit handler, e.currentTarget is the form)
    const formData = new FormData(e.currentTarget);
    const form = formData.get("form");
    const dest = formData.get("dest");
    const orig = formData.get("orig");
    const funds = formData.get("funds");
    const free_jumpseats = formData.get("free_jumpseats");

    // Check if destination matches current location
    if (dest.toUpperCase() === props.pilotData.location.toUpperCase()) {
      setLoading(false);
      setShowLocationModal(true);
      return;
    }

    console.log(
      "form:" +
        form +
        " dest:" +
        dest +
        " orig:" +
        orig +
        " free_jumpseats:" +
        free_jumpseats +
        " funds:" +
        funds
    );

    try {
      // 4. Clean API call using Axios config object
      const { data } = await axios.get("/api/jumpseat", {
        params: {
          form,
          orig,
          dest,
          funds,
          free_jumpseats,
          _t: Date.now(), // cleaner cache-buster than Math.random()
        },
      });

      // Handle data responses here
      if (data) {
        console.log(data);
        if (data.result === "error") {
          console.log("Error message: " + data.mesg);
          setError(data.mesg);
        }
        if (data.result === "success" && data.action === "cost") {
          setMesg("You have adequate funds to pay for jumpseat.");
          setDest(data.location);
          setCost(data.cost);
          setStage(2);
        }
        if (data.result === "success" && data.action === "paid_jumpseat") {
          console.log("Used a free jumpseat");
          setMesg("You have used a free jumpseat");
          setDest(data.location || dest);
          
          // Prepare updated data
          const newJumpseats = data.jumpseats !== undefined ? parseInt(data.jumpseats) : (parseInt(props.pilotData.jumpseats) || 0);
          const newFunds = data.funds !== undefined ? parseFloat(data.funds) : (parseFloat(props.pilotData.funds) || 0);
          
          setUpdatedJumpseats(newJumpseats);
          setUpdatedFunds(newFunds);
          
          // Update pilotData and localStorage
          if (props.setPilotData) {
            const updatedData = {
              ...props.pilotData,
              jumpseats: newJumpseats,
              funds: newFunds,
              location: data.location || dest
            };
            props.setPilotData(updatedData);
            localStorage.setItem("userData", JSON.stringify(updatedData));
          }
          setStage(3);
        }
        if (data.result === "success" && data.action === "free_jumpseat") {
          console.log("Free jumpseat");
          setMesg("You used a free jumpseat.");
          setDest(data.location || dest);
          
          // Prepare updated data
          const newFunds = data.funds !== undefined ? parseFloat(data.funds) : (parseFloat(props.pilotData.funds) || 0);
          const newJumpseats = data.jumpseats !== undefined ? parseInt(data.jumpseats) : (parseInt(props.pilotData.jumpseats) || 0);
          
          setUpdatedFunds(newFunds);
          setUpdatedJumpseats(newJumpseats);
          
          // Update pilotData and localStorage
          if (props.setPilotData) {
            const updatedData = {
              ...props.pilotData,
              funds: newFunds,
              jumpseats: newJumpseats,
              location: data.location || dest
            };
            props.setPilotData(updatedData);
            localStorage.setItem("userData", JSON.stringify(updatedData));
          }
          setStage(3);
        }
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("Failed to fetch jumpseat info. Please try again.");
    } finally {
      // 5. This runs regardless of success or failure
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <TopNav page={props.page} darkMode={props.darkmode} />
      <BackButton />
      
      {/* Modal for same location warning */}
      {showLocationModal && (
        <div className="modal-overlay" onClick={() => setShowLocationModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>⚠️ Same Location</h2>
            </div>
            <div className="modal-body">
              <p>You are already at that location.</p>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-primary"
                onClick={() => setShowLocationModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`jumpseat-container ${props.darkmode ? "dark-theme" : "light-theme"}`}>
        {/* Header Section */}
        <div className="jumpseat-header-section">
          <div className="jumpseat-title-group">
            <h1>
              {/* <span className="jumpseat-icon"></span> */}
              Jumpseat Operations
            </h1>
            <div className="jumpseat-subtitle">
              Instant Travel Request Form
            </div>
          </div>
        </div>

        {/* Stage 1: Initial Jumpseat Request */}
        {stage === 1 && (
          <div>
            {/* Current Location Card */}
            <div className="jumpseat-card">
              <div className="card-header">
                <span className="card-icon">📍</span>
                <h2 className="card-title">Current Location</h2>
              </div>
              <div className="info-box">
                <strong>Point-to-Point Rule:</strong> Your departure airport must be
                the same as your current location. You are currently at{" "}
                <strong>{props.pilotData.location}</strong>. You can change your
                location by flying to another airport or using a jumpseat.
              </div>
            </div>

            {/* Pilot Status Stats */}
            <div className="stats-row">
              <div className="stat-box">
                <div className="stat-icon">💺</div>
                <span className="stat-label">Free Jumpseats</span>
                <div className="stat-value">
                  {props.pilotData.jumpseats || 0}
                </div>
              </div>
              <div className="stat-box">
                <div className="stat-icon">💰</div>
                <span className="stat-label">Available Funds</span>
                <div className="stat-value">
                  v{props.pilotData.funds || 0}
                </div>
              </div>
              <div className="stat-box">
                <div className="stat-icon">🌐</div>
                <span className="stat-label">Current Airport</span>
                <div className="stat-value">{props.pilotData.location}</div>
              </div>
            </div>

            {/* Free Jumpseats Available */}
            {props.pilotData.jumpseats && props.pilotData.jumpseats > 0 && (
              <div className="jumpseat-card">
                <div className="card-header">
                  <span className="card-icon">🎫</span>
                  <h2 className="card-title">Free Jumpseats Available</h2>
                </div>
                <div className="info-box success">
                  <strong>Great news!</strong> You have{" "}
                  <strong>{props.pilotData.jumpseats}</strong> free jumpseat
                  {props.pilotData.jumpseats > 1 ? "s" : ""} at your disposal. Use a
                  jumpseat to instantly change your current location to another
                  airport by entering the ICAO code below.
                </div>
              </div>
            )}

            {/* No Free Jumpseats */}
            {(!props.pilotData.jumpseats || props.pilotData.jumpseats === 0) && (
              <div className="jumpseat-card">
                <div className="card-header">
                  <span className="card-icon">💳</span>
                  <h2 className="card-title">Paid Jumpseat Service</h2>
                </div>
                <div className="info-box warning">
                  <strong>No free jumpseats available.</strong> You can purchase a
                  jumpseat by entering the ICAO code of your destination airport
                  below. The system will calculate the cost based on distance.
                  <br />
                  <br />
                  Available funds: <strong>v{props.pilotData.funds}</strong>
                </div>
              </div>
            )}

            {/* Jumpseat Request Form */}
            <div className="jumpseat-card">
              <div className="card-header">
                <span className="card-icon">🎯</span>
                <h2 className="card-title">Request Jumpseat</h2>
              </div>
              <form className="jumpseat-form" onSubmit={handleForm1}>
                <input type="hidden" name="form" value="1" />
                <input type="hidden" name="orig" value="LSGG" />
                <input
                  type="hidden"
                  name="free_jumpseats"
                  value={props.pilotData.jumpseats}
                />
                <input
                  type="hidden"
                  name="funds"
                  value={props.pilotData.funds}
                />

                <div className="form-group">
                  <label className="form-label">
                    <span className="card-icon">🛫</span>
                    Destination Airport (ICAO Code)
                  </label>
                  <input
                    type="text"
                    name="dest"
                    className="form-input"
                    placeholder="e.g., KJFK, EGLL, LFPG"
                    tabIndex="1"
                    maxLength="4"
                    pattern="[A-Za-z]{4}"
                    title="Please enter a valid 4-letter ICAO code"
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary"
                  tabIndex="2"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="loading-spinner"></span>
                      Processing...
                    </>
                  ) : (
                    <>
                      <span>✈️</span>
                      Request Jumpseat
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        )}

        {/* Stage 2: Payment Confirmation */}
        {stage === 2 && (
          <div>
            <div className="jumpseat-card">
              <div className="card-header">
                <span className="card-icon">💳</span>
                <h2 className="card-title">Confirm Jumpseat Purchase</h2>
              </div>

              <div className="info-box">
                Review the details below and confirm your purchase.
              </div>

              <div className="confirmation-details">
                <div className="detail-row">
                  <div className="detail-item">
                    <span className="detail-label">Route</span>
                    <span className="detail-value">{props.pilotData.location} → {dest}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Cost</span>
                    <span className="detail-value highlight">v{cost}</span>
                  </div>
                </div>
                <div className="detail-row">
                  <div className="detail-item">
                    <span className="detail-label">Current Balance</span>
                    <span className="detail-value">v{props.pilotData.funds}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Remaining Balance</span>
                    <span className="detail-value">v{props.pilotData.funds - cost}</span>
                  </div>
                </div>
              </div>

              <form className="jumpseat-form" onSubmit={handleForm2}>
                <input type="hidden" name="form" value="2" />
                <input type="hidden" name="dest" value={dest} />
                <input type="hidden" name="cost" value={cost} />

                <div className="button-group">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setStage(1)}
                    disabled={loading}
                  >
                    <span>❌</span>
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    tabIndex="2"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="loading-spinner"></span>
                        Processing Payment...
                      </>
                    ) : (
                      <>
                        <span>✅</span>
                        Confirm & Purchase
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Stage 3: Success Message */}
        {stage === 3 && (
          <div>
            <div className="jumpseat-card">
              <div className="success-message">
                <div className="success-icon"></div>
                <h2 className="success-title">Jumpseat Confirmed!</h2>
                <div className="success-text">
                  <p>
                    You have successfully used a jumpseat. Your location has been
                    updated to <strong>{dest}</strong>.
                  </p>
                  <p>Welcome to your new location. Enjoy your flight!</p>
                </div>
              </div>
{/* 
              {mesg && (
                <div className="info-box success" style={{ marginTop: "20px" }}>
                  {mesg}
                </div>
              )} */}

              <div className="stats-row" style={{ marginTop: "30px" }}>
                <div className="stat-box">
                  <div className="stat-icon">📍</div>
                  <span className="stat-label">New Location</span>
                  <div className="stat-value">{dest}</div>
                </div>
                <div className="stat-box">
                  <div className="stat-icon">💺</div>
                  <span className="stat-label">Remaining Free Jumpseats</span>
                  <div className="stat-value">
                    {updatedJumpseats !== null ? updatedJumpseats : (props.pilotData?.jumpseats || 0)}
                  </div>
                </div>
                <div className="stat-box">
                  <div className="stat-icon">💰</div>
                  <span className="stat-label">Available Funds</span>
                  <div className="stat-value">
                    v{updatedFunds !== null ? Number(updatedFunds).toFixed(2) : (props.pilotData?.funds || 0)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {error} {mesg}
    </React.Fragment>
  );
};

export default JumpseatPage;
